(() => {
  const MAX_PAGES = 30;
  const CACHE_TTL_MS = 2 * 60 * 1000;
  const SOLD_OUT_GRID_ATTRIBUTE = 'data-lorenzos-global-sold-out-grid';

  const adapters = [
    {
      id: 'standard',
      rootSelector: '.collection-content[data-section-id]',
      wrapperSelector: '#CollectionProductGrid.lorenzos-collection-grid',
      gridSelector: ':scope > .grid.grid--uniform',
      itemSelector: ':scope > .lorenzos-collection-card__item',
      paginationSelector: '.pagination',
      isSoldOut: (item) => (
        item.classList.contains('lorenzos-collection-card__item--sold-out')
        || Boolean(item.querySelector('.lorenzos-collection-card--sold-out'))
      ),
      ensureSoldOutSection: (wrapper, grid) => {
        let section = wrapper.querySelector(':scope > .lorenzos-sold-out-products');

        if (!section) {
          section = document.createElement('section');
          section.className = 'lorenzos-sold-out-products';
          section.hidden = true;
          section.setAttribute('aria-label', 'Gerade ausverkaufte Produkte');
          section.innerHTML = `
            <div class="lorenzos-sold-out-products__header">
              <div>
                <p class="lorenzos-sold-out-products__kicker">Bald wieder da</p>
                <h2 class="lorenzos-sold-out-products__title">Gerade ausverkauft</h2>
              </div>
              <p class="lorenzos-sold-out-products__text">Diese Spezialit&auml;ten sind aktuell nicht verf&uuml;gbar. Du kannst dich auf der Produktseite benachrichtigen lassen.</p>
            </div>
            <div class="lorenzos-sold-out-products__grid" ${SOLD_OUT_GRID_ATTRIBUTE}></div>
          `;
          grid.insertAdjacentElement('afterend', section);
        }

        let soldOutGrid = section.querySelector(`[${SOLD_OUT_GRID_ATTRIBUTE}]`);
        if (!soldOutGrid) {
          soldOutGrid = section.querySelector('[data-lorenzos-sold-out-grid]');
          soldOutGrid?.setAttribute(SOLD_OUT_GRID_ATTRIBUTE, '');
        }

        return { section, soldOutGrid };
      },
    },
    {
      id: 'premium',
      rootSelector: '.lg-category-funnel',
      wrapperSelector: '.lg-category-funnel__product-section',
      gridSelector: ':scope > .lg-category-funnel__products',
      itemSelector: ':scope > .lg-category-funnel__product-card',
      paginationSelector: '.lg-category-funnel__pagination',
      isSoldOut: (item) => Boolean(
        item.querySelector('.lg-category-funnel__badge--soldout')
        || item.querySelector('.lg-category-funnel__product-button--soldout')
      ),
      ensureSoldOutSection: (wrapper, grid) => {
        let section = wrapper.querySelector(':scope > .lorenzos-premium-sold-out-products');

        if (!section) {
          section = document.createElement('section');
          section.className = 'lorenzos-premium-sold-out-products';
          section.hidden = true;
          section.setAttribute('aria-label', 'Gerade ausverkaufte Produkte');
          section.innerHTML = `
            <div class="lorenzos-premium-sold-out-products__header">
              <div>
                <p class="lorenzos-premium-sold-out-products__kicker">Bald wieder da</p>
                <h2>Gerade ausverkauft</h2>
              </div>
              <p>Diese Spezialit&auml;ten sind aktuell nicht verf&uuml;gbar. Du kannst dich auf der Produktseite benachrichtigen lassen.</p>
            </div>
            <div class="lg-category-funnel__products lorenzos-premium-sold-out-products__grid" ${SOLD_OUT_GRID_ATTRIBUTE}></div>
          `;
          grid.insertAdjacentElement('afterend', section);
        }

        return {
          section,
          soldOutGrid: section.querySelector(`[${SOLD_OUT_GRID_ATTRIBUTE}]`),
        };
      },
    },
  ];

  let runToken = 0;

  const installPremiumStyles = () => {
    if (document.getElementById('lorenzos-premium-sold-out-pagination-styles')) return;

    const style = document.createElement('style');
    style.id = 'lorenzos-premium-sold-out-pagination-styles';
    style.textContent = `
      .lorenzos-premium-sold-out-products {
        margin-top: 34px;
        padding-top: 26px;
        border-top: 1px solid rgba(217, 199, 173, 0.82);
      }
      .lorenzos-premium-sold-out-products[hidden] { display: none !important; }
      .lorenzos-premium-sold-out-products__header {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        gap: 18px;
        margin-bottom: 18px;
      }
      .lorenzos-premium-sold-out-products__header h2 { margin: 0; }
      .lorenzos-premium-sold-out-products__header > p {
        max-width: 390px;
        margin: 0;
        text-align: right;
      }
      .lorenzos-premium-sold-out-products__kicker {
        display: inline-flex;
        margin: 0 0 7px;
        padding: 5px 11px;
        border-radius: 999px;
        background: rgba(204, 242, 137, 0.62);
        color: #111;
        font-size: 0.75rem;
        font-weight: 900;
        letter-spacing: 0.08em;
        line-height: 1;
        text-transform: uppercase;
      }
      @media only screen and (max-width: 768px) {
        .lorenzos-premium-sold-out-products { margin-top: 28px; padding-top: 22px; }
        .lorenzos-premium-sold-out-products__header { display: block; margin-bottom: 14px; }
        .lorenzos-premium-sold-out-products__header > p { margin-top: 7px; text-align: left; }
      }
    `;
    document.head.appendChild(style);
  };

  const currentPage = () => {
    const value = Number.parseInt(new URL(window.location.href).searchParams.get('page') || '1', 10);
    return Number.isFinite(value) && value > 0 ? value : 1;
  };

  const sectionIdFromRoot = (root) => {
    if (root.dataset.sectionId) return root.dataset.sectionId;
    const sectionHost = root.closest('[id^="shopify-section-"]');
    return sectionHost?.id.replace(/^shopify-section-/, '') || '';
  };

  const findContext = (scope = document, requestedAdapterId = null) => {
    const possibleAdapters = requestedAdapterId
      ? adapters.filter((adapter) => adapter.id === requestedAdapterId)
      : adapters;

    for (const adapter of possibleAdapters) {
      const root = scope.querySelector(adapter.rootSelector);
      const wrapper = root?.querySelector(adapter.wrapperSelector);
      const grid = wrapper?.querySelector(adapter.gridSelector);
      if (!root || !wrapper || !grid) continue;

      return {
        adapter,
        root,
        wrapper,
        grid,
        pagination: root.querySelector(adapter.paginationSelector),
        sectionId: sectionIdFromRoot(root),
      };
    }

    return null;
  };

  const productKey = (item, fallbackIndex) => {
    const card = item.matches('[data-product-id], [data-product-handle]')
      ? item
      : item.querySelector('[data-product-id], [data-product-handle]');

    return card?.dataset.productId
      || card?.dataset.productHandle
      || item.querySelector('a[href*="/products/"]')?.getAttribute('href')
      || `product-${fallbackIndex}`;
  };

  const buildRequestUrl = (sectionId, page) => {
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('page', String(page));
    return url.toString();
  };

  const buildCacheKey = (adapterId, sectionId) => {
    const url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    url.hash = '';
    return `lorenzos-availability-pages-v2:${adapterId}:${sectionId}:${url.pathname}?${url.searchParams.toString()}`;
  };

  const readCache = (key) => {
    try {
      const raw = window.sessionStorage.getItem(key);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed?.savedAt || Date.now() - parsed.savedAt > CACHE_TTL_MS) {
        window.sessionStorage.removeItem(key);
        return null;
      }
      return parsed;
    } catch (_error) {
      return null;
    }
  };

  const writeCache = (key, payload) => {
    try {
      window.sessionStorage.setItem(key, JSON.stringify({ ...payload, savedAt: Date.now() }));
    } catch (_error) {
      // Sorting still works when storage is blocked or full.
    }
  };

  const linkPageNumber = (href) => {
    try {
      const value = Number.parseInt(new URL(href, window.location.origin).searchParams.get('page') || '1', 10);
      return Number.isFinite(value) ? value : 1;
    } catch (_error) {
      return 1;
    }
  };

  const parsePage = (html, adapterId, pageNumber) => {
    const documentPage = new DOMParser().parseFromString(html, 'text/html');
    const context = findContext(documentPage, adapterId);
    if (!context) return { itemHtml: [], hasNextPage: false };

    const items = Array.from(context.grid.querySelectorAll(context.adapter.itemSelector));
    const hasNextPage = context.pagination
      ? Array.from(context.pagination.querySelectorAll('a[href]'))
        .some((link) => linkPageNumber(link.getAttribute('href')) > pageNumber)
      : false;

    return {
      itemHtml: items.map((item) => item.outerHTML),
      hasNextPage,
    };
  };

  const fetchAllPages = async (context, cacheKey, token) => {
    const cached = readCache(cacheKey);
    if (cached?.pages?.length) return cached.pages;

    const pages = [];

    for (let page = 1; page <= MAX_PAGES; page += 1) {
      if (token !== runToken) return [];

      const response = await fetch(buildRequestUrl(context.sectionId, page), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (!response.ok) {
        throw new Error(`Collection page ${page} returned HTTP ${response.status}`);
      }

      const parsed = parsePage(await response.text(), context.adapter.id, page);
      if (!parsed.itemHtml.length && page === 1) return [];

      pages.push(parsed);
      if (!parsed.hasNextPage) break;
      if (page === MAX_PAGES) {
        throw new Error(`Collection has more than ${MAX_PAGES} pages; sorting was skipped safely.`);
      }
    }

    writeCache(cacheKey, { pages });
    return pages;
  };

  const createItem = (html) => {
    const template = document.createElement('template');
    template.innerHTML = html.trim();
    return template.content.firstElementChild;
  };

  const replaceCurrentPage = (pages, token, adapterId) => {
    if (token !== runToken) return;

    const context = findContext(document, adapterId);
    if (!context) return;
    if (pages.length <= 1) {
      context.wrapper.setAttribute('aria-busy', 'false');
      return;
    }

    const pageSize = Math.max(...pages.map((page) => page.itemHtml.length));
    if (!Number.isFinite(pageSize) || pageSize <= 0) return;

    const uniqueItems = [];
    const seenProducts = new Set();

    pages.forEach((page) => {
      page.itemHtml.forEach((html) => {
        const item = createItem(html);
        if (!item) return;

        const key = productKey(item, uniqueItems.length);
        if (seenProducts.has(key)) return;
        seenProducts.add(key);
        uniqueItems.push(item);
      });
    });

    const availableItems = uniqueItems.filter((item) => !context.adapter.isSoldOut(item));
    const soldOutItems = uniqueItems.filter((item) => context.adapter.isSoldOut(item));
    const sortedItems = [...availableItems, ...soldOutItems];
    const pageIndex = Math.min(Math.max(currentPage() - 1, 0), pages.length - 1);
    const visibleItems = sortedItems.slice(pageIndex * pageSize, (pageIndex + 1) * pageSize);
    const { section, soldOutGrid } = context.adapter.ensureSoldOutSection(context.wrapper, context.grid);
    if (!section || !soldOutGrid) return;

    context.grid.replaceChildren();
    soldOutGrid.replaceChildren();

    visibleItems.forEach((item) => {
      if (context.adapter.isSoldOut(item)) soldOutGrid.appendChild(item);
      else context.grid.appendChild(item);
    });

    section.hidden = soldOutGrid.childElementCount === 0;
    context.wrapper.dataset.globalAvailabilitySorted = 'true';
    context.wrapper.setAttribute('aria-busy', 'false');

    document.dispatchEvent(new CustomEvent('lorenzos:collection-availability-sorted', {
      detail: {
        template: adapterId,
        currentPage: pageIndex + 1,
        totalPages: pages.length,
        availableProducts: availableItems.length,
        soldOutProducts: soldOutItems.length,
      },
    }));
  };

  const run = async () => {
    const token = ++runToken;
    const context = findContext();

    if (!context?.sectionId || !context.pagination) return;
    if (context.adapter.id === 'premium') installPremiumStyles();

    context.wrapper.setAttribute('aria-busy', 'true');

    try {
      const cacheKey = buildCacheKey(context.adapter.id, context.sectionId);
      const pages = await fetchAllPages(context, cacheKey, token);
      replaceCurrentPage(pages, token, context.adapter.id);
    } catch (error) {
      if (token === runToken) {
        context.wrapper.setAttribute('aria-busy', 'false');
        console.warn('[Lorenzos] Global availability sorting could not be applied.', error);
      }
    }
  };

  const scheduleRun = () => {
    window.setTimeout(run, 0);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRun, { once: true });
  } else {
    scheduleRun();
  }

  document.addEventListener('collection:reloaded', scheduleRun);
  document.addEventListener('shopify:section:load', scheduleRun);
})();
